import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  IconButton,
  LinearProgress,
  FormControl,
  MenuItem,
  Select,
  Avatar,
  RadioGroup,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  Divider,
  Alert,
  Grid,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import {
  validateName,
  validateShopName,
  validateEmail,
  validatePhoneNumber,
  validateDropdown,
  validateDropdownForArray,
  validateDOB,
  validateAadhar,
  validatePAN,
  validateGST,
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../utils/textFieldValidations";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { InputLabel, FormControlLabel, Checkbox } from "@mui/material";
import { Delete, UploadFile, CloudUpload } from "@mui/icons-material";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BoltIcon from "@mui/icons-material/Bolt";
import Header from "./userHeader";
import { UserFooter } from "..";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

import {
  convertDate,
  convertDateToDateMonthYear,
} from "../../utils/DateFormats";

import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";

const StyledPaper = styled(Paper)({
  padding: "24px",
  border: "1px solid #e0e0e0",
  borderRadius: "12px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
});

const ImageUploadBox = styled(Box)({
  border: "2px dashed #ddd",
  borderRadius: "8px",
  padding: "40px 20px",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  backgroundColor: "#fafafa",
  "&:hover": {
    borderColor: "#4c6ef5",
    backgroundColor: "#f0f4ff",
  },
});

// Responsive Grid Container Component

const BlueBanner = () => {
  const items = [
    {
      icon: <TrackChangesIcon sx={{ color: "#1947E5", fontSize: 20 }} />,
      title: "Reach 10,000+ local customers",
    },
    {
      icon: <MonetizationOnIcon sx={{ color: "#0B8A00", fontSize: 20 }} />,
      title: "Zero commission for first 3 months",
    },
    {
      icon: <LocalShippingIcon sx={{ color: "#E67E22", fontSize: 20 }} />,
      title: "Free delivery support",
    },
    {
      icon: <BoltIcon sx={{ color: "#C0392B", fontSize: 20 }} />,
      title: "Get approved within 24 hours",
    },
  ];
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #4c6ef5 0%, #5f3dc4 100%)",
        padding: "32px 20px",
        borderRadius: "14px",
        marginBottom: "24px",
        boxShadow: "0 6px 22px rgba(76,110,245,0.25)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          flexDirection: "column",
          margin: "0 auto",
        }}
      >
        <IconButton onClick={() => navigate("/")} sx={{ color: "white" }}>
          <HomeIcon />
          <Typography sx={{ fontSize: "1.15rem", fontWeight: "bold", mt: 0.5 }}>
            Home
          </Typography>
        </IconButton>
      </Box>
      <Typography
        variant="h6"
        sx={{
          color: "white",
          textAlign: "center",
          fontWeight: 700,
          marginBottom: "16px",
          fontSize: "21px",
        }}
      >
        Join 500+ Local Vendors on Sthanick
      </Typography>

      <Typography
        variant="subtitle2"
        sx={{
          color: "rgba(255,255,255,0.95)",
          textAlign: "center",
          marginBottom: "22px",
          fontSize: "15px",
        }}
      >
        Reach thousands of local customers and grow your business.
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: "12px",
          "@media (max-width: 900px)": {
            flexWrap: "wrap",
          },
        }}
      >
        {items.map((item, index) => (
          <Card
            key={index}
            sx={{
              background: "rgba(255,255,255,0.97)",
              borderRadius: "8px",
              padding: "10px",
              flex: "1",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              transition: "0.2s",
              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              },
              "@media (max-width: 900px)": {
                flex: "1 1 calc(50% - 12px)",
              },
              "@media (max-width: 600px)": {
                flex: "1 1 100%",
              },
            }}
          >
            <Box sx={{ "& svg": { fontSize: "26px" } }}>{item.icon}</Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "#333",
                fontSize: "13px",
                lineHeight: 1.4,
              }}
            >
              {item.title}
            </Typography>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

const Vendorseller = ({ onBack }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const profileImageInputRef = useRef(null);
  const storeImageInputRef = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [natureData, setNatureData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [isEditMode, setEditMode] = useState(false);
  const [selectedStoreImageFile, setSelectedStoreImageFile] = useState(null);
  const [listingCategoryData, setListingCategoryData] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);
  const [isModalOpen, setModalOpen] = useState(false);
  const [generatedCredentials, setGeneratedCredentials] = useState(null);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  const steps = ["Basic Info", "Store Details", "Address", "Submit"];

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
  });

  const [vendorData, setVendorData] = useState({
    name: "",
    shopName: "",
    location: "",
    email: "",
    phoneNumber: "",
    businessNature: "",
    status: "",
    category: [],
    profilePhoto: "",
    storeImage: "",
    openingTime: "",
    eveningTime: "",
    dob: null,
    aadhar: "",
    pan: "",
    gst: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    searchlocation: "",
    latitude: "",
    longitude: "",
    password: "",
    id: "",
    productType: "",
    listingCategory: [],
  });

  // API Integration
  useEffect(() => {
    fetchBusinessNatureData();
  }, []);

  useEffect(() => {
    if (vendorData?.productType === "regular") {
      fetchCategory();
    } else if (vendorData?.productType === "listing") {
      fetchListingCategory();
    }
  }, [vendorData?.productType]);

  const {
    data: businessNatureData,
    isLoading: isbusinessNatureLoading,
    error: businessNatureError,
    fetchData: fetchBusinessNatureData,
  } = useFetch(BASE_URL_TEST + urls("getAllBNature"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: allCategoryData,
    isLoading: isCategoryLoading,
    error: categoryError,
    fetchData: fetchCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: allListingCategoryData,
    isLoading: isListingCategoryLoading,
    error: listingCategoryError,
    fetchData: fetchListingCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: createVendorsData,
    isLoading: createVendorsLoading,
    error: createVendorsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVendor"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (businessNatureError) {
    } else if (businessNatureData && businessNatureData["status"] === true) {
      setNatureData(businessNatureData["data"]);
    }
  }, [businessNatureData, businessNatureError]);

  useEffect(() => {
    if (categoryError) {
    } else if (allCategoryData && allCategoryData["status"] === true) {
      const filteredCategories = allCategoryData["data"].filter(
        (item) => item.status === 1,
      );
      setCategoryData(filteredCategories);
    }
  }, [allCategoryData, categoryError]);

  useEffect(() => {
    if (listingCategoryError) {
    } else if (
      allListingCategoryData &&
      allListingCategoryData["status"] === true
    ) {
      const filteredListingCategories = allListingCategoryData["data"].filter(
        (item) => item.status === 1,
      );
      setListingCategoryData(filteredListingCategories);
    }
  }, [allListingCategoryData, listingCategoryError]);

  useEffect(() => {
    if (createVendorsError) {
    } else if (createVendorsData && createVendorsData["status"] === true) {
      setSnackbarState({
        message: createVendorsData["message"],
        status: createVendorsData["status"],
      });
      setModalOpen(true);
    } else if (createVendorsData && createVendorsData["status"] === false) {
      setSnackbarState({
        message: createVendorsData["message"],
        status: createVendorsData["status"],
      });
      setModalOpen(true);
    }
  }, [createVendorsData, createVendorsError]);

  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;
    setVendorData({
      ...vendorData,
      searchlocation: searchValue,
    });

    const query = `${vendorData["country"]}, ${vendorData["state"]}, ${searchValue}`;

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          query,
        )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
      );

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;

        setVendorData((prevData) => ({
          ...prevData,
          latitude: lat,
          longitude: lng,
        }));

        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(15);
        }
        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setVendorData((vendorData) => ({
          ...vendorData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    }
  }, []);

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    return null;
  };

  const LocationPicker = ({ setLatitude, setLongitude }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  const validateImageFile = (
    file,
    maxSizeKB,
    requiredWidth,
    requiredHeight,
  ) => {
    return new Promise((resolve, reject) => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > maxSizeKB) {
        reject(
          `File size should be less than ${maxSizeKB}KB. Current size: ${Math.round(
            fileSizeKB,
          )}KB`,
        );
        return;
      }

      if (!file.type.match(/image\/(jpeg|jpg|png)/)) {
        reject("Only JPEG and PNG images are allowed");
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        if (img.width !== requiredWidth || img.height !== requiredHeight) {
          reject(
            `Image dimensions should be ${requiredWidth}x${requiredHeight}. Current: ${img.width}x${img.height}`,
          );
        } else {
          resolve(true);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject("Error loading image");
      };

      img.src = objectUrl;
    });
  };

  const validateStep = (step) => {
    let validationErrors = {};

    if (step === 0) {
      if (!validateName(vendorData.name)) {
        validationErrors.name =
          "Name is required and should only contain letters and spaces.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateCity(vendorData.location)) {
        validationErrors.location =
          "Location is required and should only contain letters and spaces.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateEmail(vendorData.email)) {
        validationErrors.email = "Please enter a valid email address.";
        setErrors(validationErrors);
        return false;
      }

      if (!validatePhoneNumber(vendorData.phoneNumber)) {
        validationErrors.phoneNumber = "Please enter a 10 digit phone number.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.productType) {
        validationErrors.productType = "Please select product type.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.businessNature) {
        validationErrors.businessNature = "Please select business nature.";
        setErrors(validationErrors);
        return false;
      }

      if (vendorData.productType === "regular") {
        if (!vendorData.category || vendorData.category.length === 0) {
          validationErrors.category = "Please select at least one category.";
          setErrors(validationErrors);
          return false;
        }
      }

      if (vendorData.productType === "listing") {
        if (
          !vendorData.listingCategory ||
          vendorData.listingCategory.length === 0
        ) {
          validationErrors.listingCategory =
            "Please select at least one listing category.";
          setErrors(validationErrors);
          return false;
        }
      }
    } else if (step === 1) {
      if (!validateShopName(vendorData.shopName)) {
        validationErrors.shopName = "Shop Name is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.profilePhoto) {
        validationErrors.profilePhoto =
          "Store Image is required. Please upload an image (300x300, Max 40KB).";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.storeImage) {
        validationErrors.storeImage =
          "Store Banner is required. Please upload an image (1250x400, Max 60KB).";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.openingTime) {
        validationErrors.openingTime = "Please select opening time.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.eveningTime) {
        validationErrors.eveningTime = "Please select closing time.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.dob) {
        validationErrors.dob = "Date of birth is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateAadhar(vendorData.aadhar)) {
        validationErrors.aadhar = "Aadhar number must be a 12-digit number.";
        setErrors(validationErrors);
        return false;
      }

      if (!validatePAN(vendorData.pan)) {
        validationErrors.pan =
          "Please enter a valid PAN number (e.g., ABCDE1234F).";
        setErrors(validationErrors);
        return false;
      }

      if (
        vendorData.productType === "regular" &&
        !validateGST(vendorData.gst)
      ) {
        validationErrors.gst = "Please enter a valid GST number.";
        setErrors(validationErrors);
        return false;
      }
    } else if (step === 2) {
      if (!validateCountry(vendorData.country)) {
        validationErrors.country = "Country is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateState(vendorData.state)) {
        validationErrors.state = "State is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateStreet(vendorData.street)) {
        validationErrors.street = "Street is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!validateLandmark(vendorData.landmark)) {
        validationErrors.landmark = "Landmark is required.";
        setErrors(validationErrors);
        return false;
      }

      if (!validatePincode(vendorData.pincode)) {
        validationErrors.pincode = "Pincode should be a 6-digit number.";
        setErrors(validationErrors);
        return false;
      }

      if (!vendorData.searchlocation) {
        validationErrors.searchlocation = "Location is required.";
        setErrors(validationErrors);
        return false;
      }
    }

    setErrors({});
    return true;
  };

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
    setErrors({});
    window.scrollTo(0, 0);
  };

  const handleSubmit = () => {
    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    let aadharPrefix = vendorData.aadhar.slice(0, 2);
    const covertDate = vendorData.dob ? convertDate(vendorData.dob) : null;
    let dobMonth = covertDate.split("-")[1];
    let dobMonthAbbr = months[parseInt(dobMonth, 10) - 1];
    let dobMonthWithAt = `${dobMonthAbbr}@`;
    let dobYear = covertDate.split("-")[0];
    let dobYearLastTwo = dobYear.slice(2);
    let password = `${aadharPrefix}${dobMonthWithAt}${dobYearLastTwo}`;

    const formdata = new FormData();
    formdata.append("name", vendorData["name"]);
    formdata.append("shop_name", vendorData["shopName"]);
    formdata.append("location", vendorData["location"]);
    formdata.append("email", vendorData["email"]);
    formdata.append("phone_number", vendorData["phoneNumber"]);
    formdata.append("business_id", vendorData["businessNature"]);
    formdata.append("status", "pending");

    if (vendorData?.productType === "regular") {
      formdata.append("category_id", vendorData["category"]);
    }
    if (vendorData?.productType === "listing") {
      formdata.append("category_id", vendorData["listingCategory"]);
    }

    formdata.append(
      "profile",
      selectedProfileFile ? selectedProfileFile : vendorData["profile"],
    );
    formdata.append(
      "store_image",
      selectedStoreImageFile
        ? selectedStoreImageFile
        : vendorData["storeImage"],
    );
    formdata.append("open_time", vendorData["openingTime"]);
    formdata.append("close_time", vendorData["eveningTime"]);
    formdata.append(
      "dob",
      vendorData.dob ? convertDateToDateMonthYear(vendorData.dob) : null,
    );
    formdata.append("aadhar", vendorData["aadhar"]);
    formdata.append("pancard", vendorData["pan"]);
    formdata.append("gstn_no", vendorData["gst"]);
    formdata.append("country", vendorData["country"]);
    formdata.append("state", vendorData["state"]);
    formdata.append("city", vendorData["location"]);
    formdata.append("street", vendorData["street"]);
    formdata.append("landmark", vendorData["landmark"]);
    formdata.append("pincode", vendorData["pincode"]);
    formdata.append("latitude", vendorData["latitude"]);
    formdata.append("longitude", vendorData["longitude"]);
    formdata.append("password", password);

    const username = vendorData.email;
    const passwordDescription = `Password is formed by:
- First two digits of Aadhar
- Next month code 
- @
- Last two digits of the year (Ex:12JAN@94)`;

    setGeneratedCredentials({
      username,
      passwordDescription,
    });

    if (vendorData.productType === "regular") {
      formdata.append("reg_list_type", "regular");
    } else if (vendorData.productType === "listing") {
      formdata.append("reg_list_type", "listing");
    }

    if (!isEditMode) {
      fetchCreateData(formdata);
    }
  };

  const clearErrors = () => {
    setErrors({});
  };

  const handleProfileImage = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        await validateImageFile(file, 40, 300, 300);
        setVendorData((prevData) => ({
          ...prevData,
          profilePhoto: URL.createObjectURL(file),
        }));
        setSelectedProfileFile(file);
        if (errors.profilePhoto) {
          setErrors((prev) => ({ ...prev, profilePhoto: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, profilePhoto: error }));
        e.target.value = null;
      }
    }
  };

  const handleStoreImage = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        await validateImageFile(file, 60, 1250, 400);
        setVendorData((prevData) => ({
          ...prevData,
          storeImage: URL.createObjectURL(file),
        }));
        setSelectedStoreImageFile(file);
        if (errors.storeImage) {
          setErrors((prev) => ({ ...prev, storeImage: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, storeImage: error }));
        e.target.value = null;
      }
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    clearErrors();

    if (createVendorsData && createVendorsData["status"] === true) {
      setVendorData({
        name: "",
        shopName: "",
        location: "",
        email: "",
        phoneNumber: "",
        businessNature: "",
        status: "",
        category: [],
        profilePhoto: "",
        storeImage: "",
        openingTime: "",
        eveningTime: "",
        dob: null,
        aadhar: "",
        pan: "",
        gst: "",
        country: "",
        state: "",
        city: "",
        street: "",
        landmark: "",
        pincode: "",
        searchlocation: "",
        latitude: "",
        longitude: "",
        password: "",
        id: "",
        productType: "",
        listingCategory: [],
      });
      setActiveStep(0);
    }

    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <Box>
            <Typography
              variant="h6"
              sx={{ mb: 3, color: "#4c6ef5", fontWeight: "bold" }}
            >
              Basic Information
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <TextField
                label="Name"
                fullWidth
                value={vendorData.name}
                onChange={(e) => {
                  setVendorData({ ...vendorData, name: e.target.value });
                  if (errors.name) setErrors((prev) => ({ ...prev, name: "" }));
                }}
                error={!!errors.name}
                helperText={errors.name}
              />

              <TextField
                label="Location"
                fullWidth
                value={vendorData.location}
                onChange={(e) => {
                  setVendorData({ ...vendorData, location: e.target.value });
                  if (errors.location)
                    setErrors((prev) => ({ ...prev, location: "" }));
                }}
                error={!!errors.location}
                helperText={errors.location}
              />
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <TextField
                label="Email"
                type="email"
                fullWidth
                value={vendorData.email}
                onChange={(e) => {
                  setVendorData({ ...vendorData, email: e.target.value });
                  if (errors.email)
                    setErrors((prev) => ({ ...prev, email: "" }));
                }}
                error={!!errors.email}
                helperText={errors.email}
              />

              <TextField
                label="Phone"
                type="tel"
                fullWidth
                value={vendorData.phoneNumber}
                onChange={(e) => {
                  setVendorData({ ...vendorData, phoneNumber: e.target.value });
                  if (errors.phoneNumber)
                    setErrors((prev) => ({ ...prev, phoneNumber: "" }));
                }}
                error={!!errors.phoneNumber}
                helperText={errors.phoneNumber}
              />
            </Box>

            <FormControl component="fieldset" sx={{ mb: 2 }}>
              <Typography
                variant="body1"
                sx={{ fontWeight: 600, mb: 1, color: "#333" }}
              >
                Product Type
              </Typography>
              <RadioGroup
                row
                name="productType"
                value={vendorData?.productType || ""}
                onChange={(e) =>
                  !isEditMode &&
                  setVendorData({ ...vendorData, productType: e.target.value })
                }
              >
                <FormControlLabel
                  value="regular"
                  control={<Radio />}
                  label="Sthanick Stores"
                  disabled={isEditMode}
                />
                <FormControlLabel
                  value="listing"
                  control={<Radio />}
                  label="Sthanick Services"
                  disabled={isEditMode}
                />
              </RadioGroup>
              {errors.productType && (
                <Typography sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}>
                  {errors.productType}
                </Typography>
              )}
            </FormControl>

            <Box
              sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2 }}
            >
              <FormControl fullWidth error={!!errors.businessNature}>
                <InputLabel>Business Nature</InputLabel>
                <Select
                  value={vendorData.businessNature || ""}
                  onChange={(e) => {
                    setVendorData({
                      ...vendorData,
                      businessNature: e.target.value,
                    });
                    if (errors.businessNature)
                      setErrors((prev) => ({ ...prev, businessNature: "" }));
                  }}
                  label="Business Nature"
                >
                  {natureData && natureData.length > 0 ? (
                    natureData.map((businessNature) => (
                      <MenuItem
                        key={businessNature.business_id}
                        value={businessNature.business_id}
                      >
                        {businessNature.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No business nature available</MenuItem>
                  )}
                </Select>
                {errors.businessNature && (
                  <Typography sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}>
                    {errors.businessNature}
                  </Typography>
                )}
              </FormControl>

              {vendorData?.productType === "regular" && (
                <FormControl fullWidth error={!!errors.category}>
                  <InputLabel>Category</InputLabel>
                  <Select
                    multiple
                    value={
                      Array.isArray(vendorData?.category)
                        ? vendorData.category
                        : []
                    }
                    onChange={(e) => {
                      setVendorData({
                        ...vendorData,
                        category: Array.isArray(e.target.value)
                          ? e.target.value
                          : [],
                      });
                      if (errors.category)
                        setErrors((prev) => ({ ...prev, category: "" }));
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0) return "Select Categories";
                      const selectedCategories = categoryData.filter(
                        (category) => selected.includes(category.category_id),
                      );
                      return selectedCategories
                        .map((category) => category.name)
                        .join(", ");
                    }}
                    label="Category"
                  >
                    {Array.isArray(categoryData) && categoryData.length > 0 ? (
                      categoryData.map((category) => (
                        <MenuItem
                          key={category.category_id}
                          value={category.category_id}
                        >
                          <Checkbox
                            checked={
                              Array.isArray(vendorData?.category) &&
                              vendorData?.category.includes(
                                category.category_id,
                              )
                            }
                          />
                          {category.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No categories available</MenuItem>
                    )}
                  </Select>
                  {errors.category && (
                    <Typography
                      sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}
                    >
                      {errors.category}
                    </Typography>
                  )}
                </FormControl>
              )}

              {vendorData?.productType === "listing" && (
                <FormControl fullWidth error={!!errors.listingCategory}>
                  <InputLabel>Listing Category</InputLabel>
                  <Select
                    multiple
                    value={
                      Array.isArray(vendorData?.listingCategory)
                        ? vendorData.listingCategory
                        : []
                    }
                    onChange={(e) => {
                      setVendorData({
                        ...vendorData,
                        listingCategory: Array.isArray(e.target.value)
                          ? e.target.value
                          : [],
                      });
                      if (errors.listingCategory)
                        setErrors((prev) => ({ ...prev, listingCategory: "" }));
                    }}
                    renderValue={(selected) => {
                      if (selected.length === 0)
                        return "Select Listing Categories";
                      const selectedCategories = listingCategoryData.filter(
                        (category) => selected.includes(category.category_id),
                      );
                      return selectedCategories
                        .map((category) => category.name)
                        .join(", ");
                    }}
                    label="Listing Category"
                  >
                    {Array.isArray(listingCategoryData) &&
                    listingCategoryData.length > 0 ? (
                      listingCategoryData.map((category) => (
                        <MenuItem
                          key={category.category_id}
                          value={category.category_id}
                        >
                          <Checkbox
                            checked={
                              Array.isArray(vendorData?.listingCategory) &&
                              vendorData?.listingCategory.includes(
                                category.category_id,
                              )
                            }
                          />
                          {category.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>
                        No listing categories available
                      </MenuItem>
                    )}
                  </Select>
                  {errors.listingCategory && (
                    <Typography
                      sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}
                    >
                      {errors.listingCategory}
                    </Typography>
                  )}
                </FormControl>
              )}
            </Box>
          </Box>
        );

      case 1:
        return (
          <Box>
            <Typography
              variant="h6"
              sx={{ mb: 3, color: "#4c6ef5", fontWeight: "bold" }}
            >
              Store Details
            </Typography>

            <Box sx={{ mb: 2 }}>
              <TextField
                label="Shop Name"
                fullWidth
                value={vendorData.shopName}
                onChange={(e) => {
                  setVendorData({ ...vendorData, shopName: e.target.value });
                  if (errors.shopName)
                    setErrors((prev) => ({ ...prev, shopName: "" }));
                }}
                error={!!errors.shopName}
                helperText={errors.shopName}
              />
            </Box>

            {/* Store Image Section */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Store Image (Front or inside store)
              </Typography>

              <Box sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
                <Box sx={{ textAlign: "center" }}>
                  <Avatar
                    alt="Store Image"
                    src={vendorData?.profilePhoto || "/default-profile.png"}
                    sx={{
                      width: 150,
                      height: 150,
                      border: "2px solid #ddd",
                      mb: 1,
                      borderRadius: 0,
                    }}
                    variant="square"
                  />
                  <Typography variant="caption" color="textSecondary">
                    Required: 300 × 300 pixels
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    display="block"
                  >
                    Max size: 40KB (JPEG/PNG)
                  </Typography>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<CloudUpload />}
                      sx={{ bgcolor: "#4c6ef5" }}
                    >
                      Upload Image
                      <input
                        hidden
                        accept="image/*"
                        ref={profileImageInputRef}
                        type="file"
                        onChange={handleProfileImage}
                      />
                    </Button>

                    <Button
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => {
                        setVendorData((prev) => ({
                          ...prev,
                          profilePhoto: "",
                        }));
                        setSelectedProfileFile(null);
                        if (profileImageInputRef.current)
                          profileImageInputRef.current.value = null;
                      }}
                      sx={{ color: "red", borderColor: "red" }}
                    >
                      Delete
                    </Button>
                  </Box>

                  {errors.profilePhoto && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                      {errors.profilePhoto}
                    </Alert>
                  )}
                </Box>
              </Box>
            </Box>

            {/* Store Banner Section */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                Store Banner (Flexi/Banner, Front side of the Store view)
              </Typography>

              {vendorData?.storeImage && (
                <Box
                  sx={{
                    mb: 2,
                    textAlign: "center",
                    p: 2,
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                  }}
                >
                  <img
                    src={vendorData.storeImage}
                    alt="Store Banner"
                    style={{
                      width: "100%",
                      maxHeight: 250,
                      objectFit: "contain",
                    }}
                  />
                </Box>
              )}

              <Box
                sx={{
                  border: "2px dashed #ddd",
                  borderRadius: "4px",
                  p: 3,
                  textAlign: "center",
                  cursor: "pointer",
                  "&:hover": { borderColor: "#4c6ef5" },
                }}
                onClick={() => storeImageInputRef.current?.click()}
              >
                <CloudUpload sx={{ fontSize: 48, color: "#4c6ef5", mb: 2 }} />
                <Typography variant="h6">Add Store Banner</Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Required: 1250 x 400 pixels
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Max size: 60KB | Format: JPEG, PNG
                </Typography>
              </Box>

              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={storeImageInputRef}
                onChange={handleStoreImage}
              />

              {errors.storeImage && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {errors.storeImage}
                </Alert>
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <FormControl fullWidth error={!!errors.openingTime}>
                <InputLabel>Opening Time</InputLabel>
                <Select
                  value={vendorData.openingTime || ""}
                  onChange={(e) => {
                    setVendorData({
                      ...vendorData,
                      openingTime: e.target.value,
                    });
                    if (errors.openingTime)
                      setErrors((prev) => ({ ...prev, openingTime: "" }));
                  }}
                  label="Opening Time"
                >
                  {[
                    "12:00 AM",
                    "12:30 AM",
                    "01:00 AM",
                    "01:30 AM",
                    "02:00 AM",
                    "02:30 AM",
                    "03:00 AM",
                    "03:30 AM",
                    "04:00 AM",
                    "04:30 AM",
                    "05:00 AM",
                    "05:30 AM",
                    "06:00 AM",
                    "06:30 AM",
                    "07:00 AM",
                    "07:30 AM",
                    "08:00 AM",
                  ].map((t) => (
                    <MenuItem key={t} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </Select>
                {errors.openingTime && (
                  <Typography sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}>
                    {errors.openingTime}
                  </Typography>
                )}
              </FormControl>

              <FormControl fullWidth error={!!errors.eveningTime}>
                <InputLabel>Closing Time</InputLabel>
                <Select
                  value={vendorData.eveningTime || ""}
                  onChange={(e) => {
                    setVendorData({
                      ...vendorData,
                      eveningTime: e.target.value,
                    });
                    if (errors.eveningTime)
                      setErrors((prev) => ({ ...prev, eveningTime: "" }));
                  }}
                  label="Closing Time"
                >
                  {[
                    "12:00 PM",
                    "12:30 PM",
                    "01:00 PM",
                    "01:30 PM",
                    "02:00 PM",
                    "02:30 PM",
                    "03:00 PM",
                    "03:30 PM",
                    "04:00 PM",
                    "04:30 PM",
                    "05:00 PM",
                    "05:30 PM",
                    "06:00 PM",
                    "06:30 PM",
                    "07:00 PM",
                    "07:30 PM",
                    "08:00 PM",
                    "08:30 PM",
                    "09:00 PM",
                    "09:30 PM",
                    "10:00 PM",
                    "10:30 PM",
                    "11:00 PM",
                    "11:30 PM",
                  ].map((t) => (
                    <MenuItem key={t} value={t}>
                      {t}
                    </MenuItem>
                  ))}
                </Select>
                {errors.eveningTime && (
                  <Typography sx={{ color: "#d32f2f", fontSize: 12, mt: 0.5 }}>
                    {errors.eveningTime}
                  </Typography>
                )}
              </FormControl>
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Date of Birth"
                    value={vendorData.dob}
                    maxDate={new Date()}
                    onChange={(newVal) => {
                      setVendorData({ ...vendorData, dob: newVal });
                      if (errors.dob)
                        setErrors((prev) => ({ ...prev, dob: "" }));
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!errors.dob,
                        helperText: errors.dob,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Box sx={{ flex: 1 }}>
                <TextField
                  label="Aadhar Number"
                  fullWidth
                  value={vendorData.aadhar}
                  onChange={(e) => {
                    const v = e.target.value.replace(/\D/g, "").slice(0, 12);
                    setVendorData({ ...vendorData, aadhar: v });
                    if (errors.aadhar)
                      setErrors((prev) => ({ ...prev, aadhar: "" }));
                  }}
                  error={!!errors.aadhar}
                  helperText={errors.aadhar}
                />
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                label="PAN Number"
                fullWidth
                value={vendorData.pan}
                onChange={(e) => {
                  const v = e.target.value.toUpperCase().slice(0, 10);
                  setVendorData({ ...vendorData, pan: v });
                  if (errors.pan) setErrors((prev) => ({ ...prev, pan: "" }));
                }}
                error={!!errors.pan}
                helperText={errors.pan}
                placeholder="Example: ABCDE1234F"
              />

              <TextField
                label="GST Number (Optional for Listing)"
                fullWidth
                value={vendorData.gst}
                onChange={(e) => {
                  const v = e.target.value.toUpperCase().slice(0, 15);
                  setVendorData({ ...vendorData, gst: v });
                  if (errors.gst) setErrors((prev) => ({ ...prev, gst: "" }));
                }}
                error={!!errors.gst}
                helperText={errors.gst}
                placeholder="Example: 27AAAPA1234A1Z5"
              />
            </Box>
          </Box>
        );

      case 2:
        return (
          <Box>
            <Typography
              variant="h6"
              sx={{ mb: 3, color: "#4c6ef5", fontWeight: "bold" }}
            >
              Address Information
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                label="Country"
                fullWidth
                value={vendorData.country}
                onChange={(e) => {
                  setVendorData({ ...vendorData, country: e.target.value });
                  if (errors.country)
                    setErrors((prev) => ({ ...prev, country: "" }));
                }}
                error={!!errors.country}
                helperText={errors.country}
              />

              <TextField
                label="State"
                fullWidth
                value={vendorData.state}
                onChange={(e) => {
                  setVendorData({ ...vendorData, state: e.target.value });
                  if (errors.state)
                    setErrors((prev) => ({ ...prev, state: "" }));
                }}
                error={!!errors.state}
                helperText={errors.state}
              />

              <TextField
                label="City"
                fullWidth
                value={vendorData.location}
                InputProps={{ readOnly: true }}
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
              <TextField
                label="Street Address"
                fullWidth
                value={vendorData.street}
                onChange={(e) => {
                  setVendorData({ ...vendorData, street: e.target.value });
                  if (errors.street)
                    setErrors((prev) => ({ ...prev, street: "" }));
                }}
                error={!!errors.street}
                helperText={errors.street}
              />

              <TextField
                label="Landmark"
                fullWidth
                value={vendorData.landmark}
                onChange={(e) => {
                  setVendorData({ ...vendorData, landmark: e.target.value });
                  if (errors.landmark)
                    setErrors((prev) => ({ ...prev, landmark: "" }));
                }}
                error={!!errors.landmark}
                helperText={errors.landmark}
              />

              <TextField
                label="Pincode"
                fullWidth
                value={vendorData.pincode}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/g, "").slice(0, 6);
                  setVendorData({ ...vendorData, pincode: v });
                  if (errors.pincode)
                    setErrors((prev) => ({ ...prev, pincode: "" }));
                }}
                error={!!errors.pincode}
                helperText={errors.pincode}
              />
            </Box>

            <Box sx={{ mb: 2 }}>
              <TextField
                label="Search Location"
                fullWidth
                value={vendorData.searchlocation}
                onChange={(e) => {
                  handleLocationSearch(e);
                  if (errors.searchlocation)
                    setErrors((prev) => ({ ...prev, searchlocation: "" }));
                }}
                error={!!errors.searchlocation}
                helperText={errors.searchlocation}
                placeholder="Enter location to search on map"
              />
            </Box>

            <Box
              sx={{
                p: 3,
                border: "1px solid #ccc",
                borderRadius: "12px",
                bgcolor: "#fafafa",
                mb: 2,
              }}
            >
              <GoogleMap
                ref={mapRef}
                center={{
                  lat: parseFloat(vendorData.latitude) || 0,
                  lng: parseFloat(vendorData.longitude) || 0,
                }}
                zoom={13}
                mapContainerStyle={{
                  height: 400,
                  width: "100%",
                  borderRadius: "8px",
                }}
              >
                <LocationPicker
                  setLatitude={(lat) =>
                    setVendorData((prev) => ({ ...prev, latitude: lat }))
                  }
                  setLongitude={(lon) =>
                    setVendorData((prev) => ({ ...prev, longitude: lon }))
                  }
                />

                {vendorData.latitude && vendorData.longitude && (
                  <MarkerF
                    position={{
                      lat: parseFloat(vendorData.latitude),
                      lng: parseFloat(vendorData.longitude),
                    }}
                  />
                )}
              </GoogleMap>
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                label="Latitude"
                fullWidth
                value={vendorData.latitude}
                InputProps={{ readOnly: true }}
              />

              <TextField
                label="Longitude"
                fullWidth
                value={vendorData.longitude}
                InputProps={{ readOnly: true }}
              />
            </Box>
          </Box>
        );

      case 3:
        return (
          <Box>
            <Typography
              variant="h5"
              sx={{
                mb: 3,
                color: "#4c6ef5",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Review Your Information
            </Typography>

            <Paper sx={{ p: 3, mb: 3, borderRadius: "12px" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", mb: 2, color: "#4c6ef5" }}
              >
                Basic Information
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Name
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.name}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Shop Name
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.shopName}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Email
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.email}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Phone Number
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.phoneNumber}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Product Type
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, textTransform: "capitalize" }}
                  >
                    {vendorData.productType}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Location
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.location}
                  </Typography>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{ p: 3, mb: 3, borderRadius: "12px" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", mb: 2, color: "#4c6ef5" }}
              >
                Store Details
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Opening Time
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.openingTime}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Closing Time
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.eveningTime}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Date of Birth
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.dob
                      ? new Date(vendorData.dob).toLocaleDateString()
                      : ""}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Aadhar
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.aadhar}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    PAN
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.pan}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    GST
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.gst || "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{ p: 3, borderRadius: "12px" }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", mb: 2, color: "#4c6ef5" }}
              >
                Address Details
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Street Address
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.street}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Landmark
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.landmark}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    State
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.state}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Country
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.country}
                  </Typography>
                </Box>

                <Box sx={{ flex: "1 1 45%" }}>
                  <Typography variant="caption" color="textSecondary">
                    Pincode
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {vendorData.pincode}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Box>
        );

      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 1100,
        mx: "auto",
        p: 3,
        bgcolor: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <BlueBanner />

      <StyledPaper>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((s) => (
            <Step key={s}>
              <StepLabel>{s}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box>{renderStepContent()}</Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 4,
            pt: 3,
            borderTop: "2px solid #e0e0e0",
          }}
        >
          <Button
            variant="outlined"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{
              minWidth: 120,
              borderColor: "#4c6ef5",
              color: "#4c6ef5",
              "&:hover": { borderColor: "#3b5bdb", bgcolor: "#f0f4ff" },
            }}
          >
            Back
          </Button>

          {activeStep < steps.length - 1 ? (
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                minWidth: 120,
                bgcolor: "#4c6ef5",
                "&:hover": { bgcolor: "#3b5bdb" },
              }}
            >
              Continue
            </Button>
          ) : (
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => setActiveStep(0)}
                sx={{
                  minWidth: 100,
                  borderColor: "#4c6ef5",
                  color: "#4c6ef5",
                  "&:hover": { borderColor: "#3b5bdb", bgcolor: "#f0f4ff" },
                }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={handleSubmit}
                sx={{
                  minWidth: 120,
                  bgcolor: "#2ecc71",
                  "&:hover": { bgcolor: "#27ae60" },
                }}
                disabled={createVendorsLoading}
              >
                {createVendorsLoading ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          )}
        </Box>
      </StyledPaper>

      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
              alignItems: "center",
            }}
          >
            {snackbarState.message}
          </Typography>

          {snackbarState.status === true && generatedCredentials && (
            <>
              <Typography variant="body2">
                <strong>Username:</strong> {generatedCredentials.username}
              </Typography>
              <Typography variant="body2">
                <strong>Password:</strong>{" "}
                {generatedCredentials.passwordDescription}
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Vendorseller;
